"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assetPicture = exports.ASSET_PICTURE_PREFIX = exports.creaturePicture = exports.CREATURE_PICTURE_PREFIX = void 0;
exports.CREATURE_PICTURE_PREFIX = "creature:";
const creaturePicture = (id) => `${exports.CREATURE_PICTURE_PREFIX}${id}`;
exports.creaturePicture = creaturePicture;
// A repo-bundled image (under the configured image root), e.g. "bots/robot-001.png".
exports.ASSET_PICTURE_PREFIX = "asset:";
const assetPicture = (path) => `${exports.ASSET_PICTURE_PREFIX}${path}`;
exports.assetPicture = assetPicture;
